import { Check } from "lucide-react";
import { plans, pricingNote, primaryCta } from "@/content/site";
import { Btn } from "./Ui";
import { Reveal } from "./Motion";

export default function Plans({ dark = true }) {
  return (
    <div data-testid="plans">
      <div className={`grid gap-px md:grid-cols-2 xl:grid-cols-4 ${dark ? "bg-ivory/15" : "bg-ink/15"}`}>
        {plans.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.06} className={`relative flex flex-col p-7 md:p-8 ${dark ? "bg-ink" : "bg-ivory"}`} data-testid={`plan-${p.id}`}>
            {p.featured && <span className="absolute right-0 top-0 bg-accent px-3 py-1.5 font-mono text-[12px] uppercase text-white">Le plus demandé</span>}
            <p className="label">{String(i + 1).padStart(2, "0")} — {p.name}</p>
            <p className={`mt-8 font-mono text-[12px] uppercase ${dark ? "text-[#B3BAB4]" : "text-mute"}`}>À partir de</p>
            <p className="display mt-1 text-[3.2rem] leading-none">{p.price}<span className="font-sans text-[16px] font-medium">{p.unit}</span></p>
            <p className={`mt-5 font-medium ${dark ? "text-ivory" : "text-ink"}`}>{p.desc}</p>
            <ul className={`mt-6 space-y-2.5 text-[15px] ${dark ? "text-[#CDD2CD]" : "text-mute"}`}>
              {p.items.map((it) => <li key={it} className="flex gap-2.5"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#8C96FF]" aria-hidden="true" style={dark ? undefined : { color: "#2B3BD6" }} />{it}</li>)}
            </ul>
          </Reveal>
        ))}
      </div>
      <div className="mt-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <p className={`font-mono text-[13px] ${dark ? "text-[#CDD2CD]" : "text-mute"}`} data-testid="pricing-note">{pricingNote}</p>
        <Btn to={primaryCta.to} variant={dark ? "light" : "primary"} track="cta_diagnostic" testid="plans-cta">{primaryCta.label}</Btn>
      </div>
    </div>
  );
}
